var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home back"},[_c('div',{staticClass:"background"}),_c('div',{staticClass:"backgroundOverlay"}),_c('Buchung')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }